import React, { Suspense, useEffect } from 'react';
import { AnalyticsTracker } from './components/AnalyticsTracker';
import { NavigationProvider, useLocation, useNavigate } from './navigation';
import { Root } from './Root';

const Home = React.lazy(() => import('./pages/Home').then((module) => ({ default: module.Home })));
const CronicaPage = React.lazy(() => import('./pages/CronicaPage').then((module) => ({ default: module.CronicaPage })));

function AppRoute() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isChronicle = pathname.startsWith('/cronica/');

  useEffect(() => {
    if (pathname === '/cronica') navigate('/', { replace: true });
  }, [navigate, pathname]);

  return (
    <Root showLoadingScreen={!isChronicle}>
      {isChronicle ? (
        <Suspense fallback={<div className="min-h-screen bg-brand-bg" />}>
          <CronicaPage />
        </Suspense>
      ) : (
        <Suspense fallback={<div className="min-h-screen bg-brand-bg" />}>
          <Home />
        </Suspense>
      )}
    </Root>
  );
}

export default function App() {
  return (
    <NavigationProvider>
      <AnalyticsTracker />
      <AppRoute />
    </NavigationProvider>
  );
}
